import { graphql } from "gatsby"
import React from "react"
import Layout from "../components/layout"
import { useTranslation } from "react-i18next"
import Seo from "../components/seo"

const BiographyPage = () => {
  const { t } = useTranslation()

  return (
    <Layout page={"biography"}>
      <Seo title="Bio" />
      <div className="page_container">
        <div className="biography">
          <p dangerouslySetInnerHTML={{ __html: t("first_paragraph") }}></p>
          <p dangerouslySetInnerHTML={{ __html: t("second_paragraph") }}></p>
        </div>
      </div>
    </Layout>
  )
}

export default BiographyPage

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
